import { HttpClient, queryString } from '@opallabs/api'
import handleError from '../handleError'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchLabelSets = (params) => {
  const url = new URL('/api/v1/label_sets', window.location.origin)
  url.search = queryString(params)
  return HttpClient().get(url.toString())
}

const getLabelSets =
  ({ currentBrandId, params, scopeToCurrentBrand, component }) =>
  async (dispatch, getState) => {
    const getParams = params

    if (scopeToCurrentBrand) {
      const currentState = getState()
      const brandId = currentState.current_workspace_id || currentBrandId
      getParams['filter[workspace]'] = brandId
    }

    return fetchLabelSets(getParams)
      .then((response) => dispatch(loadJsonApiEntities(response.data)))
      .catch((error) => {
        if (component) {
          dispatch(handleError({ component, error }))
        }
        throw error
      })
  }

export default getLabelSets
